import { buildCollection } from "@firecms/core";
import { rolesOf } from "../roles";
import { currencyMapProperty } from "./money";

const variantsCollection = buildCollection({
  id: "variants",
  path: "variants",
  name: "規格與售價",
  singularName: "規格",
  customId: true,
  description: "文件 ID 就是 SKU，格式為「機型-版本-容量-同捆」（例如 ATG11-ZHTW-1TB、ATG11-ZHTW-1TB-WIN）；同捆元件 WIN11-PRO-KEY 不分語言、不標版本。組合品的庫存依元件計算，自己的 stock 留空。",
  permissions: ({ authController }) => {
    const r = rolesOf(authController);
    return { read: r.staff, edit: r.staff, create: r.admin, delete: r.admin };
  },
  initialSort: ["sort", "asc"],
  propertiesOrder: ["capacity", "edition", "bundle", "stock", "prices", "compareAt", "active", "components", "weightGrams", "customs", "image", "sort"],
  properties: {
    capacity: { name: "容量", dataType: "string", validation: { required: true } },
    edition: {
      name: "系統版本",
      description: "預載 Windows 的語言，同捆元件留空",
      dataType: "string",
      enumValues: { "zh-TW": "繁體中文", "en-US": "英文" },
    },
    bundle: { name: "同捆附加品", description: "對應商品文案的 bundles，例如 win11-pro；沒有就留空", dataType: "string" },
    stock: { name: "庫存", dataType: "number", validation: { integer: true } },
    prices: currencyMapProperty("售價", "各幣別的售價（元，含稅）。每個貨幣都要填；沒填的貨幣買不到這個規格。"),
    compareAt: currencyMapProperty("原價", "有填且比售價高時，前台會顯示刪除線的原價。"),
    active: { name: "上架", dataType: "boolean" },
    components: { name: "組合元件", description: "組合品的元件 SKU，每個扣 1", dataType: "array", of: { dataType: "string" } },
    weightGrams: { name: "重量（公克，含包裝）", description: "計算國際運費用", dataType: "number", validation: { integer: true, min: 0 } },
    customs: {
      name: "報關資料",
      dataType: "map",
      properties: {
        hsCode: { name: "HS code", dataType: "string" },
        description: { name: "英文申報品名", dataType: "string" },
        origin: { name: "原產地（ISO 國碼）", dataType: "string" },
      },
    },
    image: { name: "圖片路徑", description: "public/ 底下的路徑，例如 /images/products/apptogo-11-1tb.jpg", dataType: "string" },
    sort: { name: "排序", dataType: "number" },
  },
});

export const productsCollection = buildCollection({
  id: "products",
  path: "products",
  name: "商品",
  singularName: "商品",
  group: "商品",
  icon: "inventory_2",
  customId: true,
  description: "文案與翻譯在 Git 的 content/products/；這裡只管上架狀態、售價與庫存。",
  permissions: ({ authController }) => {
    const r = rolesOf(authController);
    return { read: r.staff, edit: r.admin, create: r.admin, delete: r.admin };
  },
  initialSort: ["sort", "asc"],
  subcollections: [variantsCollection],
  properties: {
    label: { name: "後台名稱", dataType: "string", validation: { required: true } },
    slug: { name: "網址代稱", description: "對應 content/products/{slug}/", dataType: "string", validation: { required: true } },
    status: {
      name: "狀態",
      dataType: "string",
      enumValues: { active: "上架", draft: "草稿", component: "同捆元件（不單獨販售）" },
      validation: { required: true },
    },
    sort: { name: "排序", dataType: "number" },
  },
});
